export interface INavItem {
  id: string;
  title: string;
  url: string;
  section?: string;
  userAuth: boolean;
  children: INavItem[];
}

const navItems = [
  {
    id: "welcome",
    title: "Home",
    type: "item",
    url: "/welcome",
    userAuth: false, //user-authentication is not a pre-requisite for visiting this  page
    children: [],
  },
  {
    id: "products",
    title: "Products",
    type: "item",
    url: "/products",
    userAuth: false, //user-authentication is not a pre-requisite for visiting this  page
    children: [],
  },
  {
    id: "services",
    title: "Services",
    type: "item",
    url: "/services/other-services",
    userAuth: false,
    children: [],
  },
  // {
  //   id: "resource-hub",
  //   title: "WELLNESS HUB",
  //   type: "item",
  //   url: "member/resource-hub",
  //   userAuth: false,
  //   children: [],
  // },
  {
    id: "about-us",
    title: "About Us",
    type: "item",
    url: "/welcome",
    section: "about-us",
    userAuth: false,
    children: [],
  },
  {
    id: "contact-us",
    title: "Contact Us",
    type: "item",
    url: "/welcome",
    section: "contact-us",
    userAuth: false,
    children: [],
  },
  {
    id: "faq",
    title: "FAQ",
    type: "item",
    url: "/welcome",
    section: "faq",
    userAuth: false,
    children: [],
  },
];

export const silverNavItems = [
  {
    id: "welcome",
    title: "Home",
    type: "item",
    url: "/welcome",
    userAuth: false, //user-authentication is not a pre-requisite for visiting this  page
    children: [],
  },
  {
    id: "products",
    title: "Products",
    type: "item",
    url: "/products",
    userAuth: false, //user-authentication is not a pre-requisite for visiting this  page
    children: [],
  },
  {
    id: "services",
    title: "Services",
    type: "item",
    url: "/services/other-services",
    userAuth: false,
    children: [],
  },
  // {
  //   id: "resource-hub",
  //   title: "WELLNESS HUB",
  //   type: "item",
  //   url: "member/resource-hub",
  //   userAuth: false,
  //   children: [],
  // },
  {
    id: "about-us",
    title: "About Us",
    type: "item",
    url: "/welcome",
    section: "about-us",
    userAuth: false,
    children: [],
  },
  {
    id: "contact-us",
    title: "Contact Us",
    type: "item",
    url: "/welcome",
    section: "contact-us",
    userAuth: false,
    children: [],
  },
  {
    id: "faq",
    title: "FAQ",
    type: "item",
    url: "/welcome",
    section: "faq",
    userAuth: false,
    children: [],
  },
];

export const goldNavItems = [
  {
    id: "welcome",
    title: "Home",
    type: "item",
    url: "/welcome",
    userAuth: false, //user-authentication is not a pre-requisite for visiting this  page
    children: [],
  },
  {
    id: "products",
    title: "Products",
    type: "item",
    url: "/products",
    userAuth: false, //user-authentication is not a pre-requisite for visiting this  page
    children: [],
  },
  {
    id: "services",
    title: "Services",
    type: "item",
    url: "/services/other-services",
    userAuth: false,
    children: [],
  },
  // {
  //   id: "resource-hub",
  //   title: "WELLNESS HUB",
  //   type: "item",
  //   url: "member/resource-hub",
  //   userAuth: false,
  //   children: [],
  // },
  {
    id: "about-us",
    title: "About Us",
    type: "item",
    url: "/welcome",
    section: "about-us",
    userAuth: false,
    children: [],
  },
  {
    id: "contact-us",
    title: "Contact Us",
    type: "item",
    url: "/welcome",
    section: "contact-us",
    userAuth: false,
    children: [],
  },
  {
    id: "faq",
    title: "FAQ",
    type: "item",
    url: "/welcome",
    section: "faq",
    userAuth: false,
    children: [],
  },
];

export const platnumNavItems = [
  {
    id: "welcome",
    title: "Home",
    type: "item",
    url: "/welcome",
    userAuth: false, //user-authentication is not a pre-requisite for visiting this  page
    children: [],
  },
  {
    id: "products",
    title: "Products",
    type: "item",
    url: "/products",
    userAuth: false, //user-authentication is not a pre-requisite for visiting this  page
    children: [],
  },
  {
    id: "services",
    title: "Services",
    type: "item",
    url: "/services/other-services",
    userAuth: false,
    children: [],
  },
  // {
  //   id: "resource-hub",
  //   title: "WELLNESS HUB",
  //   type: "item",
  //   url: "member/resource-hub",
  //   userAuth: false,
  //   children: [],
  // },
  {
    id: "about-us",
    title: "About Us",
    type: "item",
    url: "/welcome",
    section: "about-us",
    userAuth: false,
    children: [],
  },
  {
    id: "contact-us",
    title: "Contact Us",
    type: "item",
    url: "/welcome",
    section: "contact-us",
    userAuth: false,
    children: [],
  },
  {
    id: "faq",
    title: "FAQ",
    type: "item",
    url: "/welcome",
    section: "faq",
    userAuth: false,
    children: [],
  },
];

export const diamondNavItems = [
  {
    id: "welcome",
    title: "Home",
    type: "item",
    url: "/welcome",
    userAuth: false, //user-authentication is not a pre-requisite for visiting this  page
    children: [],
  },
  {
    id: "products",
    title: "Products",
    type: "item",
    url: "/products",
    userAuth: false, //user-authentication is not a pre-requisite for visiting this  page
    children: [],
  },
  {
    id: "services",
    title: "Services",
    type: "item",
    url: "/services/other-services",
    userAuth: false,
    children: [],
  },
  // {
  //   id: "resource-hub",
  //   title: "WELLNESS HUB",
  //   type: "item",
  //   url: "member/resource-hub",
  //   userAuth: false,
  //   children: [],
  // },
  {
    id: "about-us",
    title: "About Us",
    type: "item",
    url: "/welcome",
    section: "about-us",
    userAuth: false,
    children: [],
  },
  {
    id: "contact-us",
    title: "Contact Us",
    type: "item",
    url: "/welcome",
    section: "contact-us",
    userAuth: false,
    children: [],
  },
  {
    id: "faq",
    title: "FAQ",
    type: "item",
    url: "/welcome",
    section: "faq",
    userAuth: false,
    children: [],
  },
];

export default navItems;
